import {
  authenticationChannel,
  authenticationContext,
  sessionManagement,
  ActivityMonitor
} from '@codametrix/ui-common';

const { activityMonitor } = sessionManagement;


export const getServiceDeskClient = () => {

  //@ts-ignore
  const xcaliberClient = ServiceDesk.init({
    theme: {},
    bffURL: '/api/service-desk/bff',
    getBearerToken: async () => {
      await authenticationChannel.ready;
      const token = authenticationContext.getToken();
      if (!token) {
        // Honest contract: signal "no credential" rather than resolving a fake
        // empty token (which would leave consumers issuing 401 requests). Callers
        // gate on an active session (see hasActiveSession in cases.action.ts) so
        // this is not reached during expected logout teardown.
        throw new Error('No authentication token available for Service Desk');
      }
      //Check if token already has text Bearer, appened only if it not present
      if (token && token.indexOf('Bearer') !== -1) {
        return `${token}`;
      }
      return `Bearer ${token}`;
    }
  });

  activityMonitor.on(ActivityMonitor.events.DID_REFRESH, async () => {
    if (xcaliberClient) {
      xcaliberClient.refreshToken();
    }
  });
  
  return xcaliberClient;
};
